import {ReportModel} from "@fedeltapointofsale/data-client";
import {TabReportData} from "./tab-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class TabReportModel extends ReportModel<TabReportData> {
    constructor(injector: Injector) {
        super(injector, TabReportData);
    }
}
